/* tslint:disable:max-file-line-count */
export interface PhoneCountryCodeEntry {
  name: string;
  phone: string;
  iso: string;
}

const PhoneCountryCode: PhoneCountryCodeEntry[] = [
  {
    name: 'United States',
    phone: '+1',
    iso: 'US',
  },
  {
    name: 'Afghanistan',
    phone: '+93',
    iso: 'AF',
  },
  {
    name: 'Åland Islands',
    phone: '+358',
    iso: 'AX',
  },
  {
    name: 'Albania',
    phone: '+355',
    iso: 'AL',
  },
  {
    name: 'Algeria',
    phone: '+213',
    iso: 'DZ',
  },
  {
    name: 'American Samoa',
    phone: '+1684',
    iso: 'AS',
  },
  {
    name: 'Andorra',
    phone: '+376',
    iso: 'AD',
  },
  {
    name: 'Angola',
    phone: '+244',
    iso: 'AO',
  },
  {
    name: 'Anguilla',
    phone: '+1264',
    iso: 'AI',
  },
  {
    name: 'Antarctica',
    phone: '+672',
    iso: 'AQ',
  },
  {
    name: 'Antigua and Barbuda',
    phone: '+1268',
    iso: 'AG',
  },
  {
    name: 'Argentina',
    phone: '+54',
    iso: 'AR',
  },
  {
    name: 'Armenia',
    phone: '+374',
    iso: 'AM',
  },
  {
    name: 'Aruba',
    phone: '+297',
    iso: 'AW',
  },
  {
    name: 'Australia',
    phone: '+61',
    iso: 'AU',
  },
  {
    name: 'Austria',
    phone: '+43',
    iso: 'AT',
  },
  {
    name: 'Azerbaijan',
    phone: '+994',
    iso: 'AZ',
  },
  {
    name: 'Bahamas',
    phone: '+1242',
    iso: 'BS',
  },
  {
    name: 'Bahrain',
    phone: '+973',
    iso: 'BH',
  },
  {
    name: 'Bangladesh',
    phone: '+880',
    iso: 'BD',
  },
  {
    name: 'Barbados',
    phone: '+1246',
    iso: 'BB',
  },
  {
    name: 'Belarus',
    phone: '+375',
    iso: 'BY',
  },
  {
    name: 'Belgium',
    phone: '+32',
    iso: 'BE',
  },
  {
    name: 'Belize',
    phone: '+501',
    iso: 'BZ',
  },
  {
    name: 'Benin',
    phone: '+229',
    iso: 'BJ',
  },
  {
    name: 'Bermuda',
    phone: '+1441',
    iso: 'BM',
  },
  {
    name: 'Bhutan',
    phone: '+975',
    iso: 'BT',
  },
  {
    name: 'Bolivia, Plurinational State of bolivia',
    phone: '+591',
    iso: 'BO',
  },
  {
    name: 'Bosnia and Herzegovina',
    phone: '+387',
    iso: 'BA',
  },
  {
    name: 'Botswana',
    phone: '+267',
    iso: 'BW',
  },
  {
    name: 'Bouvet Island',
    phone: '+47',
    iso: 'BV',
  },
  {
    name: 'Brazil',
    phone: '+55',
    iso: 'BR',
  },
  {
    name: 'British Indian Ocean Territory',
    phone: '+246',
    iso: 'IO',
  },
  {
    name: 'Brunei Darussalam',
    phone: '+673',
    iso: 'BN',
  },
  {
    name: 'Bulgaria',
    phone: '+359',
    iso: 'BG',
  },
  {
    name: 'Burkina Faso',
    phone: '+226',
    iso: 'BF',
  },
  {
    name: 'Burundi',
    phone: '+257',
    iso: 'BI',
  },
  {
    name: 'Cambodia',
    phone: '+855',
    iso: 'KH',
  },
  {
    name: 'Cameroon',
    phone: '+237',
    iso: 'CM',
  },
  {
    name: 'Canada',
    phone: '+1',
    iso: 'CA',
  },
  {
    name: 'Cape Verde',
    phone: '+238',
    iso: 'CV',
  },
  {
    name: 'Cayman Islands',
    phone: '+ 345',
    iso: 'KY',
  },
  {
    name: 'Central African Republic',
    phone: '+236',
    iso: 'CF',
  },
  {
    name: 'Chad',
    phone: '+235',
    iso: 'TD',
  },
  {
    name: 'Chile',
    phone: '+56',
    iso: 'CL',
  },
  {
    name: 'China',
    phone: '+86',
    iso: 'CN',
  },
  {
    name: 'Christmas Island',
    phone: '+61',
    iso: 'CX',
  },
  {
    name: 'Cocos (Keeling) Islands',
    phone: '+61',
    iso: 'CC',
  },
  {
    name: 'Colombia',
    phone: '+57',
    iso: 'CO',
  },
  {
    name: 'Comoros',
    phone: '+269',
    iso: 'KM',
  },
  {
    name: 'Congo',
    phone: '+242',
    iso: 'CG',
  },
  {
    name: 'Congo, The Democratic Republic of the Congo',
    phone: '+243',
    iso: 'CD',
  },
  {
    name: 'Cook Islands',
    phone: '+682',
    iso: 'CK',
  },
  {
    name: 'Costa Rica',
    phone: '+506',
    iso: 'CR',
  },
  {
    name: `Cote d'Ivoire`,
    phone: '+225',
    iso: 'CI',
  },
  {
    name: 'Croatia',
    phone: '+385',
    iso: 'HR',
  },
  {
    name: 'Cuba',
    phone: '+53',
    iso: 'CU',
  },
  {
    name: 'Cyprus',
    phone: '+357',
    iso: 'CY',
  },
  {
    name: 'Czech Republic',
    phone: '+420',
    iso: 'CZ',
  },
  {
    name: 'Denmark',
    phone: '+45',
    iso: 'DK',
  },
  {
    name: 'Djibouti',
    phone: '+253',
    iso: 'DJ',
  },
  {
    name: 'Dominica',
    phone: '+1767',
    iso: 'DM',
  },
  {
    name: 'Dominican Republic',
    phone: '+1',
    iso: 'DO',
  },
  {
    name: 'Ecuador',
    phone: '+593',
    iso: 'EC',
  },
  {
    name: 'Egypt',
    phone: '+20',
    iso: 'EG',
  },
  {
    name: 'El Salvador',
    phone: '+503',
    iso: 'SV',
  },
  {
    name: 'Equatorial Guinea',
    phone: '+240',
    iso: 'GQ',
  },
  {
    name: 'Eritrea',
    phone: '+291',
    iso: 'ER',
  },
  {
    name: 'Estonia',
    phone: '+372',
    iso: 'EE',
  },
  {
    name: 'Ethiopia',
    phone: '+251',
    iso: 'ET',
  },
  {
    name: 'Falkland Islands (Malvinas)',
    phone: '+500',
    iso: 'FK',
  },
  {
    name: 'Faroe Islands',
    phone: '+298',
    iso: 'FO',
  },
  {
    name: 'Fiji',
    phone: '+679',
    iso: 'FJ',
  },
  {
    name: 'Finland',
    phone: '+358',
    iso: 'FI',
  },
  {
    name: 'France',
    phone: '+33',
    iso: 'FR',
  },
  {
    name: 'French Guiana',
    phone: '+594',
    iso: 'GF',
  },
  {
    name: 'French Polynesia',
    phone: '+689',
    iso: 'PF',
  },
  {
    name: 'French Southern Territories',
    phone: '+262',
    iso: 'TF',
  },
  {
    name: 'Gabon',
    phone: '+241',
    iso: 'GA',
  },
  {
    name: 'Gambia',
    phone: '+220',
    iso: 'GM',
  },
  {
    name: 'Georgia',
    phone: '+995',
    iso: 'GE',
  },
  {
    name: 'Germany',
    phone: '+49',
    iso: 'DE',
  },
  {
    name: 'Ghana',
    phone: '+233',
    iso: 'GH',
  },
  {
    name: 'Gibraltar',
    phone: '+350',
    iso: 'GI',
  },
  {
    name: 'Greece',
    phone: '+30',
    iso: 'GR',
  },
  {
    name: 'Greenland',
    phone: '+299',
    iso: 'GL',
  },
  {
    name: 'Grenada',
    phone: '+1473',
    iso: 'GD',
  },
  {
    name: 'Guadeloupe',
    phone: '+590',
    iso: 'GP',
  },
  {
    name: 'Guam',
    phone: '+1671',
    iso: 'GU',
  },
  {
    name: 'Guatemala',
    phone: '+502',
    iso: 'GT',
  },
  {
    name: 'Guernsey',
    phone: '+44',
    iso: 'GG',
  },
  {
    name: 'Guinea',
    phone: '+224',
    iso: 'GN',
  },
  {
    name: 'Guinea-Bissau',
    phone: '+245',
    iso: 'GW',
  },
  {
    name: 'Guyana',
    phone: '+592',
    iso: 'GY',
  },
  {
    name: 'Haiti',
    phone: '+509',
    iso: 'HT',
  },
  {
    name: 'Heard Island and Mcdonald Islands',
    phone: '+0',
    iso: 'HM',
  },
  {
    name: 'Holy See (Vatican City State)',
    phone: '+379',
    iso: 'VA',
  },
  {
    name: 'Honduras',
    phone: '+504',
    iso: 'HN',
  },
  {
    name: 'Hong Kong, China',
    phone: '+852',
    iso: 'HK',
  },
  {
    name: 'Hungary',
    phone: '+36',
    iso: 'HU',
  },
  {
    name: 'Iceland',
    phone: '+354',
    iso: 'IS',
  },
  {
    name: 'India',
    phone: '+91',
    iso: 'IN',
  },
  {
    name: 'Indonesia',
    phone: '+62',
    iso: 'ID',
  },
  {
    name: 'Iran, Islamic Republic of Persian Gulf',
    phone: '+98',
    iso: 'IR',
  },
  {
    name: 'Iraq',
    phone: '+964',
    iso: 'IQ',
  },
  {
    name: 'Ireland',
    phone: '+353',
    iso: 'IE',
  },
  {
    name: 'Isle of Man',
    phone: '+44',
    iso: 'IM',
  },
  {
    name: 'Israel',
    phone: '+972',
    iso: 'IL',
  },
  {
    name: 'Italy',
    phone: '+39',
    iso: 'IT',
  },
  {
    name: 'Jamaica',
    phone: '+1876',
    iso: 'JM',
  },
  {
    name: 'Japan',
    phone: '+81',
    iso: 'JP',
  },
  {
    name: 'Jersey',
    phone: '+44',
    iso: 'JE',
  },
  {
    name: 'Jordan',
    phone: '+962',
    iso: 'JO',
  },
  {
    name: 'Kazakhstan',
    phone: '+7',
    iso: 'KZ',
  },
  {
    name: 'Kenya',
    phone: '+254',
    iso: 'KE',
  },
  {
    name: 'Kiribati',
    phone: '+686',
    iso: 'KI',
  },
  {
    name: `Korea, Democratic People's Republic of Korea`,
    phone: '+850',
    iso: 'KP',
  },
  {
    name: 'Korea, Republic of South Korea',
    phone: '+82',
    iso: 'KR',
  },
  {
    name: 'Kosovo',
    phone: '+383',
    iso: 'XK',
  },
  {
    name: 'Kuwait',
    phone: '+965',
    iso: 'KW',
  },
  {
    name: 'Kyrgyzstan',
    phone: '+996',
    iso: 'KG',
  },
  {
    name: 'Laos',
    phone: '+856',
    iso: 'LA',
  },
  {
    name: 'Latvia',
    phone: '+371',
    iso: 'LV',
  },
  {
    name: 'Lebanon',
    phone: '+961',
    iso: 'LB',
  },
  {
    name: 'Lesotho',
    phone: '+266',
    iso: 'LS',
  },
  {
    name: 'Liberia',
    phone: '+231',
    iso: 'LR',
  },
  {
    name: 'Libyan Arab Jamahiriya',
    phone: '+218',
    iso: 'LY',
  },
  {
    name: 'Liechtenstein',
    phone: '+423',
    iso: 'LI',
  },
  {
    name: 'Lithuania',
    phone: '+370',
    iso: 'LT',
  },
  {
    name: 'Luxembourg',
    phone: '+352',
    iso: 'LU',
  },
  {
    name: 'Macao, China',
    phone: '+853',
    iso: 'MO',
  },
  {
    name: 'Macedonia',
    phone: '+389',
    iso: 'MK',
  },
  {
    name: 'Madagascar',
    phone: '+261',
    iso: 'MG',
  },
  {
    name: 'Malawi',
    phone: '+265',
    iso: 'MW',
  },
  {
    name: 'Malaysia',
    phone: '+60',
    iso: 'MY',
  },
  {
    name: 'Maldives',
    phone: '+960',
    iso: 'MV',
  },
  {
    name: 'Mali',
    phone: '+223',
    iso: 'ML',
  },
  {
    name: 'Malta',
    phone: '+356',
    iso: 'MT',
  },
  {
    name: 'Marshall Islands',
    phone: '+692',
    iso: 'MH',
  },
  {
    name: 'Martinique',
    phone: '+596',
    iso: 'MQ',
  },
  {
    name: 'Mauritania',
    phone: '+222',
    iso: 'MR',
  },
  {
    name: 'Mauritius',
    phone: '+230',
    iso: 'MU',
  },
  {
    name: 'Mayotte',
    phone: '+262',
    iso: 'YT',
  },
  {
    name: 'Mexico',
    phone: '+52',
    iso: 'MX',
  },
  {
    name: 'Micronesia, Federated States of Micronesia',
    phone: '+691',
    iso: 'FM',
  },
  {
    name: 'Moldova',
    phone: '+373',
    iso: 'MD',
  },
  {
    name: 'Monaco',
    phone: '+377',
    iso: 'MC',
  },
  {
    name: 'Mongolia',
    phone: '+976',
    iso: 'MN',
  },
  {
    name: 'Montenegro',
    phone: '+382',
    iso: 'ME',
  },
  {
    name: 'Montserrat',
    phone: '+1664',
    iso: 'MS',
  },
  {
    name: 'Morocco',
    phone: '+212',
    iso: 'MA',
  },
  {
    name: 'Mozambique',
    phone: '+258',
    iso: 'MZ',
  },
  {
    name: 'Myanmar',
    phone: '+95',
    iso: 'MM',
  },
  {
    name: 'Namibia',
    phone: '+264',
    iso: 'NA',
  },
  {
    name: 'Nauru',
    phone: '+674',
    iso: 'NR',
  },
  {
    name: 'Nepal',
    phone: '+977',
    iso: 'NP',
  },
  {
    name: 'Netherlands',
    phone: '+31',
    iso: 'NL',
  },
  {
    name: 'Netherlands Antilles',
    phone: '+599',
    iso: 'AN',
  },
  {
    name: 'New Caledonia',
    phone: '+687',
    iso: 'NC',
  },
  {
    name: 'New Zealand',
    phone: '+64',
    iso: 'NZ',
  },
  {
    name: 'Nicaragua',
    phone: '+505',
    iso: 'NI',
  },
  {
    name: 'Niger',
    phone: '+227',
    iso: 'NE',
  },
  {
    name: 'Nigeria',
    phone: '+234',
    iso: 'NG',
  },
  {
    name: 'Niue',
    phone: '+683',
    iso: 'NU',
  },
  {
    name: 'Norfolk Island',
    phone: '+672',
    iso: 'NF',
  },
  {
    name: 'Northern Mariana Islands',
    phone: '+1670',
    iso: 'MP',
  },
  {
    name: 'Norway',
    phone: '+47',
    iso: 'NO',
  },
  {
    name: 'Oman',
    phone: '+968',
    iso: 'OM',
  },
  {
    name: 'Pakistan',
    phone: '+92',
    iso: 'PK',
  },
  {
    name: 'Palau',
    phone: '+680',
    iso: 'PW',
  },
  {
    name: 'Palestinian Territory, Occupied',
    phone: '+970',
    iso: 'PS',
  },
  {
    name: 'Panama',
    phone: '+507',
    iso: 'PA',
  },
  {
    name: 'Papua New Guinea',
    phone: '+675',
    iso: 'PG',
  },
  {
    name: 'Paraguay',
    phone: '+595',
    iso: 'PY',
  },
  {
    name: 'Peru',
    phone: '+51',
    iso: 'PE',
  },
  {
    name: 'Philippines',
    phone: '+63',
    iso: 'PH',
  },
  {
    name: 'Pitcairn',
    phone: '+64',
    iso: 'PN',
  },
  {
    name: 'Poland',
    phone: '+48',
    iso: 'PL',
  },
  {
    name: 'Portugal',
    phone: '+351',
    iso: 'PT',
  },
  {
    name: 'Puerto Rico',
    phone: '+1',
    iso: 'PR',
  },
  {
    name: 'Qatar',
    phone: '+974',
    iso: 'QA',
  },
  {
    name: 'Romania',
    phone: '+40',
    iso: 'RO',
  },
  {
    name: 'Russia',
    phone: '+7',
    iso: 'RU',
  },
  {
    name: 'Rwanda',
    phone: '+250',
    iso: 'RW',
  },
  {
    name: 'Reunion',
    phone: '+262',
    iso: 'RE',
  },
  {
    name: 'Saint Barthelemy',
    phone: '+590',
    iso: 'BL',
  },
  {
    name: 'Saint Helena, Ascension and Tristan Da Cunha',
    phone: '+290',
    iso: 'SH',
  },
  {
    name: 'Saint Kitts and Nevis',
    phone: '+1869',
    iso: 'KN',
  },
  {
    name: 'Saint Lucia',
    phone: '+1758',
    iso: 'LC',
  },
  {
    name: 'Saint Martin',
    phone: '+590',
    iso: 'MF',
  },
  {
    name: 'Saint Pierre and Miquelon',
    phone: '+508',
    iso: 'PM',
  },
  {
    name: 'Saint Vincent and the Grenadines',
    phone: '+1784',
    iso: 'VC',
  },
  {
    name: 'Samoa',
    phone: '+685',
    iso: 'WS',
  },
  {
    name: 'San Marino',
    phone: '+378',
    iso: 'SM',
  },
  {
    name: 'Sao Tome and Principe',
    phone: '+239',
    iso: 'ST',
  },
  {
    name: 'Saudi Arabia',
    phone: '+966',
    iso: 'SA',
  },
  {
    name: 'Senegal',
    phone: '+221',
    iso: 'SN',
  },
  {
    name: 'Serbia',
    phone: '+381',
    iso: 'RS',
  },
  {
    name: 'Seychelles',
    phone: '+248',
    iso: 'SC',
  },
  {
    name: 'Sierra Leone',
    phone: '+232',
    iso: 'SL',
  },
  {
    name: 'Singapore',
    phone: '+65',
    iso: 'SG',
  },
  {
    name: 'Slovakia',
    phone: '+421',
    iso: 'SK',
  },
  {
    name: 'Slovenia',
    phone: '+386',
    iso: 'SI',
  },
  {
    name: 'Solomon Islands',
    phone: '+677',
    iso: 'SB',
  },
  {
    name: 'Somalia',
    phone: '+252',
    iso: 'SO',
  },
  {
    name: 'South Africa',
    phone: '+27',
    iso: 'ZA',
  },
  {
    name: 'South Sudan',
    phone: '+211',
    iso: 'SS',
  },
  {
    name: 'South Georgia and the South Sandwich Islands',
    phone: '+500',
    iso: 'GS',
  },
  {
    name: 'Spain',
    phone: '+34',
    iso: 'ES',
  },
  {
    name: 'Sri Lanka',
    phone: '+94',
    iso: 'LK',
  },
  {
    name: 'Sudan',
    phone: '+249',
    iso: 'SD',
  },
  {
    name: 'Suriname',
    phone: '+597',
    iso: 'SR',
  },
  {
    name: 'Svalbard and Jan Mayen',
    phone: '+47',
    iso: 'SJ',
  },
  {
    name: 'Swaziland',
    phone: '+268',
    iso: 'SZ',
  },
  {
    name: 'Sweden',
    phone: '+46',
    iso: 'SE',
  },
  {
    name: 'Switzerland',
    phone: '+41',
    iso: 'CH',
  },
  {
    name: 'Syrian Arab Republic',
    phone: '+963',
    iso: 'SY',
  },
  {
    name: 'Taiwan',
    phone: '+886',
    iso: 'TW',
  },
  {
    name: 'Tajikistan',
    phone: '+992',
    iso: 'TJ',
  },
  {
    name: 'Tanzania, United Republic of Tanzania',
    phone: '+255',
    iso: 'TZ',
  },
  {
    name: 'Thailand',
    phone: '+66',
    iso: 'TH',
  },
  {
    name: 'Timor-Leste',
    phone: '+670',
    iso: 'TL',
  },
  {
    name: 'Togo',
    phone: '+228',
    iso: 'TG',
  },
  {
    name: 'Tokelau',
    phone: '+690',
    iso: 'TK',
  },
  {
    name: 'Tonga',
    phone: '+676',
    iso: 'TO',
  },
  {
    name: 'Trinidad and Tobago',
    phone: '+1868',
    iso: 'TT',
  },
  {
    name: 'Tunisia',
    phone: '+216',
    iso: 'TN',
  },
  {
    name: 'Turkey',
    phone: '+90',
    iso: 'TR',
  },
  {
    name: 'Turkmenistan',
    phone: '+993',
    iso: 'TM',
  },
  {
    name: 'Turks and Caicos Islands',
    phone: '+1649',
    iso: 'TC',
  },
  {
    name: 'Tuvalu',
    phone: '+688',
    iso: 'TV',
  },
  {
    name: 'Uganda',
    phone: '+256',
    iso: 'UG',
  },
  {
    name: 'Ukraine',
    phone: '+380',
    iso: 'UA',
  },
  {
    name: 'United Arab Emirates',
    phone: '+971',
    iso: 'AE',
  },
  {
    name: 'United Kingdom',
    phone: '+44',
    iso: 'GB',
  },
  {
    name: 'Uruguay',
    phone: '+598',
    iso: 'UY',
  },
  {
    name: 'Uzbekistan',
    phone: '+998',
    iso: 'UZ',
  },
  {
    name: 'Vanuatu',
    phone: '+678',
    iso: 'VU',
  },
  {
    name: 'Venezuela, Bolivarian Republic of Venezuela',
    phone: '+58',
    iso: 'VE',
  },
  {
    name: 'Vietnam',
    phone: '+84',
    iso: 'VN',
  },
  {
    name: 'Virgin Islands, British',
    phone: '+1284',
    iso: 'VG',
  },
  {
    name: 'Virgin Islands, U.S.',
    phone: '+1340',
    iso: 'VI',
  },
  {
    name: 'Wallis and Futuna',
    phone: '+681',
    iso: 'WF',
  },
  {
    name: 'Yemen',
    phone: '+967',
    iso: 'YE',
  },
  {
    name: 'Zambia',
    phone: '+260',
    iso: 'ZM',
  },
  {
    name: 'Zimbabwe',
    phone: '+263',
    iso: 'ZW',
  },
];

export default PhoneCountryCode;
